var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMythicalM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4728 4.27427H7.53365V3H16.4728V4.27427ZM6.25293 14.5003L4.97866 14.5003V9.40323H3V8.12897H4.97866V8.12256H6.25293V9.39714H17.747V8.12897V8.12271H16.7033V8.12881H7.18784V8.12271H6.25934V4.27427H7.53361V6.85454L16.4728 6.85454V4.27427H17.747V8.12256H19.0213V8.12897H21V9.40323H19.0213V14.5004H17.747V18.3488H16.4728V14.5003H17.747V10.6714H6.25293V14.5003ZM13.8921 18.3293H13.8858V19.5975H12.6435V18.3551H11.3692V19.5975H10.1014V18.3293H10.0886V17.0618H8.81425V18.3293H7.5272V14.5003H6.25293V18.3488H7.52079V19.6036H8.80792V20.8718H15.1857V19.6036H16.4663V18.3293H15.1664V17.0619H13.8922V15.7936H10.0949V17.0679H13.8921V18.3293ZM10.6969 13.2259H13.3159V14.5003H15.8708V13.2259H15.8708V11.9516H8.14831V12.4832H8.14194V14.5003H10.6969V13.2259Z",
    fill: "#FFD747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMythicalM);
export default __webpack_public_path__ + "static/media/mythical-m.8a0546e54d4103899088690688765a2d.svg";
export { ForwardRef as ReactComponent };